<template>
<ul
	v-if="now < end"
	class="countdown"
>
	<li>
		<p class="digit">
			<span v-if="now < start">Choices unlock in</span>
			<span v-else>Choose <span v-if="active && now < end">before</span><span v-else>by</span></span>
		</p>
		<p class="text">
&nbsp;
		</p>
	</li>
	<li v-if="days > 0">
		<p class="digit">
			{{ twoDigits( days ) }}
		</p>
		<p class="text">
			{{ days > 1 ? 'days' : 'day' }}
		</p>
	</li>
	<li>
		<p class="digit">
			{{ twoDigits( hours ) }}
		</p>
		<p class="text">
			{{ hours > 1 ? 'hours' : 'hour' }}
		</p>
	</li>
	<li>
		<p class="digit">
			{{ twoDigits( minutes ) }}
		</p>
		<p class="text">
			min
		</p>
	</li>
</ul>
<div
	v-else
	class="countdown"
>
	Window to make a choice has expired. A new one will appear soon
</div>
</template>

<script>
export default {
	props: {
		start: Number,
		end: Number
	},
	data: function(){
		return {
			now: new Date().getTime(),
			diff: 0,
			interval: null
		}
	},
	computed: {
		minutes(){
			return Math.trunc( this.diff / 60 ) % 60
		},
		hours(){
			return Math.trunc( this.diff / 60 / 60 ) % 24
		},
		days(){
			return Math.trunc( this.diff / 60 / 60 / 24 )
		},
		ended(){
			const ended = this.now > this.end
			this.$emit( 'updateEnded', ended )
			return ended
		},
		active(){
			const active = this.now > this.start && this.now < this.end
			this.$emit( 'updateActive', active )
			return active
		}
	},
	watch: {
		now: {
			immediate: true,
			handler( value ){
				if( this.now < this.start ){
					this.diff = this.start / 1000 - this.now / 1000
				} else if( this.now > this.start && this.now < this.end ){
					this.diff = this.end / 1000 - this.now / 1000
				} else if( this.now > this.end ){
					this.diff = 0
					clearInterval( this.interval )
				}
			}
		}
		/* active: { // doesn't work for some reason...
				immediate: true,
				handler( value ){
					console.log('active watch', value)
					this.$emit('updateActive', value)
				}
			} */
	},
	created(){
		if( !this.start || !this.end ){
			throw new Error( "Missing coundown.vue data 'start' or 'end'" )
		}

		this.interval = setInterval( () => {
			this.now = new Date().getTime()
		}, 60 * 1000 )
	},
	destroyed(){
		clearInterval( this.interval )
	},
	methods: {
		twoDigits( value ){
			if( value.toString().length <= 1 ){
				    return '0' + value.toString()
			}
			return value.toString()
		}
	}
}
</script>